export const defaultGBMapView = {
    projection: 'EPSG:27700', // Keep as 27700 by default
    center: [363373, 323373], // central England / Wales
    zoom: 7,
    maxZoom: 23,
    extent: [-225000.0, 0.0, 850000.0, 1350000.0]
};
